"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageFixedHeight = exports.flashNoTabLimit = exports.flashMultiTabLimit = exports.productLimit = exports.ProductShape = void 0;
exports.ProductShape = {
    RectangleA: "11rem",
    RectangleB: "14.75rem"
};
exports.productLimit = 20;
exports.flashMultiTabLimit = 200;
exports.flashNoTabLimit = 30;
exports.pageFixedHeight = 2.75;
